<template>
    <button @click.prevent="send" type="submit" form="exportRecipes" class="btn white-btn export-excel">
        Exporter toutes mes recettes au format excel
    </button>
</template>
<script>
export default {
    methods: {
        send() {
            this.$alert('Réservé aux <a target="_blank" href="https://etiquettable.eco2initiative.com/abonnements/">abonnements pro</a>', '', {
                dangerouslyUseHTMLString: true
            });
        }
    }
}
</script>